import { toast } from "@/components/ui/use-toast";
import { defaultHeader } from "@/src/constants/defaultItems";
import { DOMESTIC } from "@/src/constants/flightTypes";
import { HOLDED_FLIGHT_RESPONSE } from "@/src/reducers/types";
import axios, { HttpStatusCode } from "axios";
export const ReserveFlight = (payload, callback) => (dispatch) => {
  axios.post("/api/DomesticFlight/Reservation", payload, defaultHeader).then((reservationResp) => {
    if (reservationResp.status === HttpStatusCode.Ok) {
      dispatch({
        type: HOLDED_FLIGHT_RESPONSE,
        payload: reservationResp.data,
      });
      callback && callback(reservationResp.data);
    }
  })
}

export const BookFlight = (paylaod, callback) => (dispatch) => {
  localStorage.setItem('currentFlightType', DOMESTIC);
  axios.post("/api/DomesticFlight/BookFlight", paylaod, defaultHeader).then((bookResponse) => {
    if (bookResponse.status == HttpStatusCode.Ok) {
      callback && callback(bookResponse.data);
    }
    else {
      console.log(bookResponse.statusText);
    }
  })
}

export const viewTicket = (bookCode, callback) => (dispatch) => {
  axios.get(`/api/DomesticFlight/ViewTicket?BookingRef=${bookCode}`, defaultHeader)
    .then(function (resp) {
      if (resp.status == 200) {
        callback && callback(resp.data);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}